// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__z9bSV","rightAdornment":"Header_rightAdornment__3u-sY"};